export const formatNumberWithCommas = (num, digits) => {
  if (num === null || num === undefined || num === "") return "";
  const parsedNum = Number(num);
  if (isNaN(parsedNum)) return "";
  return parsedNum.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits || 0,
  });
};

export const formatToTwoDecimalPlaces = (num) => {
  if (num === null || num === undefined || num === "") {
    return "";
  }
  const parsedNum = Number(num);
  if (isNaN(parsedNum)) {
    return "";
  }
  return parsedNum.toFixed(2);
};

export const parseFormattedNumber = (value) => {
  if (value === null || value === undefined || value === "") return "";
  // remove non-numeric characters
  const cleaned = value.toString().replace(/[^0-9.-]+/g, "");
  const num = parseFloat(cleaned);
  return isNaN(num) ? "" : num;
};
